import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import { UserCustomRoleResponse } from '@app/types'
import { logger } from '@app/utils/logger'

const CustomRoleService = {
  getUserCustomRoles: async (): Promise<UserCustomRoleResponse> => {
    try {
      const response = await apiClient.get<UserCustomRoleResponse>(Endpoint.userCustomRoles)
      return response.data
    } catch (error) {
      logger.error('Error fetching user custom roles:', error)
      throw error
    }
  },

  updateUserCustomRole: async (id: number, name: string, description: string): Promise<void> => {
    try {
      await apiClient.put<void>(`${Endpoint.userCustomRoles}/${id}`, {
        name,
        description,
      })
    } catch (error) {
      logger.error('Error updating user custom role:', error)
      throw error
    }
  },

  deleteUserCustomRoles: async (id: number): Promise<void> => {
    try {
      await apiClient.delete<void>(`${Endpoint.userCustomRoles}/${id}`)
    } catch (error) {
      logger.error('Error deleting user custom role:', error)
      throw error
    }
  },

  createUserCustomRoles: async (name: string, description: string): Promise<void> => {
    try {
      await apiClient.post<void>(`${Endpoint.userCustomRoles}`, {
        name,
        description,
      })
    } catch (error) {
      logger.error('Error creating user custom role:', error)
      throw error
    }
  },
}

export { CustomRoleService }
